// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__CjX2L","pageHeaderTitle":"PageHeader_pageHeaderTitle__xyLhq","searchBar":"PageHeader_searchBar__VIUhN"};